// Simple sample button functionality
document.addEventListener('DOMContentLoaded', function() {
  const sampleButtons = document.querySelectorAll('.sample-button');
  
  sampleButtons.forEach(button => {
    // custom.sample_limit, when set. The server renders the initial in-cart state;
    // this keeps it in step as the shopper adds, or removes the sample elsewhere.
    const limit = parseInt(button.dataset.sampleLimit, 10);
    const wrap = button.closest('.sample-button-wrap');
    const tooltip = wrap && wrap.querySelector('.sample-button__tooltip');

    const setAtLimit = (atLimit) => {
      if (Number.isNaN(limit) || !tooltip) return;
      wrap.classList.toggle('sample-button-wrap--in-cart', atLimit);
      if (atLimit) {
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('aria-describedby', tooltip.id);
      } else {
        button.removeAttribute('aria-disabled');
        button.removeAttribute('aria-describedby');
      }
    };

    // Units of this sample across every cart line -- a Lead Time stamp puts
    // the late units on a line of their own.
    const countInCart = () =>
      fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
        .then((response) => response.json())
        .then((cartState) => {
          const variantId = Number(button.dataset.sampleVariantId);
          return cartState.items
            .filter((item) => item.variant_id === variantId)
            .reduce((total, item) => total + item.quantity, 0);
        });

    const syncWithCart = () => {
      if (Number.isNaN(limit) || !button.dataset.sampleVariantId) return Promise.resolve();
      return countInCart()
        .then((inCart) => setAtLimit(inCart >= limit))
        .catch(() => {});
    };

    // custom.sample_oos_lead_time, rendered only for a tracked, continue-selling
    // sample. An add the stock cannot cover -- on-hand, less what is already in
    // the cart -- still goes through, stamped with the lead time. If the cart
    // cannot be read, fall back to the on-hand count alone.
    const oosLeadTime = button.dataset.sampleOosLeadTime;
    const stock = parseInt(button.dataset.sampleStock, 10);
    const leadTimeForAdd = () => {
      if (!oosLeadTime || Number.isNaN(stock)) return Promise.resolve(null);
      return countInCart()
        .catch(() => 0)
        .then((inCart) => (inCart >= stock ? oosLeadTime : null));
    };

    if (!Number.isNaN(limit) && typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, syncWithCart);
      // Back/forward cache restores the DOM as it was, not as the cart now is.
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) syncWithCart();
      });
    }

    button.addEventListener('click', function(e) {
      e.preventDefault();

      if (this.getAttribute('aria-disabled') === 'true') return;

      const variantId = this.dataset.sampleVariantId;
      if (!variantId) return;
      
      const buttonText = this.querySelector('span');
      const originalText = buttonText.textContent;
      
      // Update button state
      buttonText.textContent = 'Adding Sample...';
      this.disabled = true;
      this.classList.add('loading');
      
      const spinner = this.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');
      
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      if (cart) {
        formData.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(this);
      }

      config.body = formData;

      leadTimeForAdd()
        .then((leadTime) => {
          if (leadTime) formData.append('properties[Lead Time]', leadTime);
          return fetch(routes.cart_add_url, config);
        })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            throw new Error(response.description || 'Error adding sample');
          }

          if (cart) {
            cart.renderContents(response);
          } else {
            window.location = window.routes.cart_url;
            return;
          }

          // Success
          buttonText.textContent = 'Sample Added!';
          this.classList.add('sample-added');

          // Reset button after delay
          setTimeout(() => {
            buttonText.textContent = originalText;
            this.classList.remove('sample-added');
            this.disabled = false;
            syncWithCart();
          }, 2000);
        })
        .catch((error) => {
          // Error
          buttonText.textContent = 'Try Again';
          this.classList.add('sample-error');

          setTimeout(() => {
            buttonText.textContent = originalText;
            this.classList.remove('sample-error');
            this.disabled = false;
          }, 3000);
        })
        .finally(() => {
          this.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
    });
  });
});
